var _path, _path2, _path3, _path4, _path5, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpenseVoucher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 12.879V2.25C19.5 1.85218 19.342 1.47064 19.0607 1.18934C18.7794 0.908035 18.3978 0.75 18 0.75H6C5.60218 0.75 5.22064 0.908035 4.93934 1.18934C4.65804 1.47064 4.5 1.85218 4.5 2.25V12.879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.284 11.4613C21.3946 11.374 21.5275 11.3197 21.6676 11.3044C21.8076 11.2891 21.9491 11.3136 22.0759 11.3749C22.2028 11.4362 22.3098 11.532 22.3848 11.6512C22.4597 11.7705 22.4997 11.9084 22.5 12.0493V21.7493C22.5 22.1471 22.342 22.5286 22.0607 22.8099C21.7794 23.0912 21.3978 23.2493 21 23.2493H3C2.60218 23.2493 2.22064 23.0912 1.93934 22.8099C1.65804 22.5286 1.5 22.1471 1.5 21.7493V12.0493C1.50032 11.9084 1.54026 11.7705 1.61525 11.6512C1.69023 11.532 1.79725 11.4362 1.92407 11.3749C2.05088 11.3136 2.19239 11.2891 2.33243 11.3044C2.47247 11.3197 2.60538 11.374 2.716 11.4613L10.147 17.3613C10.6755 17.7763 11.328 18.0019 12 18.0019C12.672 18.0019 13.3245 17.7763 13.853 17.3613L21.284 11.4613Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.808 15.8052L18.75 18.7472"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.192 15.8052L5.25 18.7472"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.606 3.646L14.55 10.5H9L7.5 6H15.9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M14.175 13.5C13.9679 13.5 13.8 13.3321 13.8 13.125C13.8 12.9179 13.9679 12.75 14.175 12.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M14.175 13.5C14.3822 13.5 14.55 13.3321 14.55 13.125C14.55 12.9179 14.3822 12.75 14.175 12.75"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M9.375 13.5C9.16789 13.5 9 13.3321 9 13.125C9 12.9179 9.16789 12.75 9.375 12.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M9.375 13.5C9.58211 13.5 9.75 13.3321 9.75 13.125C9.75 12.9179 9.58211 12.75 9.375 12.75"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseVoucher);
export default __webpack_public_path__ + "static/media/expense-voucher.507751235a2d2fa83841c55d14e2abd7.svg";
export { ForwardRef as ReactComponent };